import {
  ITeamLeadPermissionsJson,
  ITeamLeadPodTypeJson,
} from '@scale/shared/types/expertManagement';
import { useQuery } from 'react-query';
import { GLOBAL_ROLES } from 'react-scale/components/ExpertManagement/constants';
import {
  ClientState,
  loggedInUserSelector,
  setPermissionsSelector,
  useClientStore,
} from 'react-scale/components/ExpertManagement/stores/client.store';
import {
  StatContextState,
  useStatContextStore,
} from 'react-scale/components/ExpertManagement/stores/statContext.store';
import apiFetch from 'react-scale/lib/api-fetch';
import { shallow } from 'zustand/shallow';

const statContextSelectors = (state: StatContextState) => ({
  podTypes: state.podTypes,
  setPodTypeFilter: state.setPodTypeFilter,
});

const clientSelectors = (state: ClientState) => ({
  loggedInUser: loggedInUserSelector(state),
  setPermissions: setPermissionsSelector(state),
});

export const useFetchTeamLeadPermissions = () => {
  const { setPodTypeFilter } = useStatContextStore(statContextSelectors, shallow);
  const { setPermissions } = useClientStore(clientSelectors, shallow);
  return useQuery(
    [`fetchPermissions`],
    () =>
      apiFetch<ITeamLeadPermissionsJson>(null, 'internal/expert-management/permissions', {
        method: 'GET',
      }),
    {
      onSuccess: data => {
        setPermissions(data);
        if (
          data.roles.every(r => !GLOBAL_ROLES.includes(r)) &&
          (data.permissionedPodTypes ?? []).length === 1
        ) {
          setPodTypeFilter((data.permissionedPodTypes![0] as ITeamLeadPodTypeJson)._id);
        }
      },
      staleTime: 60 * 60 * 1000,
      enabled: false,
    },
  );
};
